import * as React from 'react'
import { FC, memo, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import Title from '@organisms/Title'
import DeleteButton from '@templates/DeleteButton'
import LineFields from '@templates/AddNewItemModal/Content/LineFields'
import FieldComponent from '@templates/Field'
import RiskSignificance from '@templates/RiskSignificance'
import { ExternalLineWrapper } from '@templates/AddNewItemModal/Content/LineFields/styled'
import { useAppDispatch } from '@hooks/useAppDispatch'
import {
  deleteSelectedMeresForms,
  deleteSelectedProtectionMeansForms,
} from '@services/riskMapModal'
import { memoEqual } from '@utils/memo'
import { log } from '@utils/console'
import useCommonRiskMapFields from '../../useCommonRiskMapFields'
import useCalculateSignificance from './useCalculateSignificance'
import {
  Container,
  RiskSignificanceWrapper,
  SecondLine,
  TitleWrapper,
  Wrapper,
} from './styled'
import useAutoPrefillHardGradeAndPossibility from './useAutoPrefillHardGradeAndPossibility'
import DangersFieldsMeresModalButton from './DangersFieldsMeresModalButton'
import DangersFieldsProtectionMeansModalButton from './DangersFieldsProtectionMeansModalButton'

type Props = {
  id: string
  index: number
  remove: (index: number) => void
  isLast: boolean
}

const DangersFieldsBlock: FC<Props> = ({ id, index, remove, isLast }) => {
  const dispatch = useAppDispatch()

  const methods = useFormContext()

  useAutoPrefillHardGradeAndPossibility(methods, index)
  const calculateSignificanceData = useCalculateSignificance(methods, index)

  const {
    dangerWorkPlacesField,
    dangersObjects,
    dangerKindsField,
    dangerHazardsField,
    dangerEventsField,
    hardGradeField,
    probabilityField,
  } = useCommonRiskMapFields(methods, { index })

  const handleDelete = useCallback(() => {
    log('handleDelete', index)
    dispatch(deleteSelectedMeresForms(index))
    dispatch(deleteSelectedProtectionMeansForms(index))
    remove(index)
  }, [dispatch, index, remove])

  return (
    <Container isLast={isLast} id={`risk-map-danger-fields-${index}`}>
      <Wrapper key={id}>
        <TitleWrapper>
          <Title>Опасность</Title>
          <DeleteButton onClick={handleDelete} id="risk-map-danger-delete">
            Удалить опасность
          </DeleteButton>
          <DangersFieldsMeresModalButton index={index} />
          <DangersFieldsProtectionMeansModalButton index={index} />
        </TitleWrapper>
        <ExternalLineWrapper>
          <LineFields
            fields={[
              dangerWorkPlacesField(),
              dangersObjects(),
              dangerKindsField(),
              dangerHazardsField(),
            ]}
          />
        </ExternalLineWrapper>
        <SecondLine>
          {[dangerEventsField(), hardGradeField(), probabilityField()].map(
            (item) => (
              <FieldComponent key={item.name} {...item} />
            )
          )}
          {calculateSignificanceData && (
            <FieldComponent
              label="Значимость риска"
              Component={() => (
                <RiskSignificanceWrapper>
                  <RiskSignificance children={calculateSignificanceData} />
                </RiskSignificanceWrapper>
              )}
              name="important"
            />
          )}
        </SecondLine>
      </Wrapper>
    </Container>
  )
}

export default memo(DangersFieldsBlock, memoEqual)
